import { FETCH_PROMOTORA_SUCCESS,DELETE_DATA } from "../constants";
const initialState = {
    promotoras: [],
    updateSucces: false,
  };

  const promotorasReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PROMOTORA_SUCCESS:
        return {
          ...state,
          promotoras: action.promotoras,
        };
        case DELETE_DATA:
          return{
            ...state,
            promotoras: state.promotoras.filter((promotora) => promotora.id !== action.payload),
          };
      default:
        return state;
    }
  };
  
  export default promotorasReducer;